
import React, {useMemo, useContext, useEffect, useState} from 'react';
import {Input, Checkbox} from 'views/FormElements';
import {OrderContext} from 'views/order/OrderForm';
import ProductUtil from 'util/ProductUtil';

const PhotoFrameSizeInput = ({imgWidth, imgHeight}) => {
    const aspectRatio = useMemo(() => imgHeight/imgWidth, [imgWidth, imgHeight]);
    const {values, setFieldValue} = useContext(OrderContext);
    const imageUploaded = values.customerUploadedImage !== null && imgWidth && imgHeight;
    const sizeData = values.productSizeMetaData;
    const sizeKeys = Object.keys(sizeData);
    const selectedSize = values.productSize;
    const selectedSizeData = selectedSize? sizeData[selectedSize]: null;
    const customWidth = values.customWidth;
    const isCustomSizeChecked = values.isCustomSize;

    const [customSizError, setCustomSizeError] = useState(null);

    useEffect(() => {
        if(imgWidth && imgHeight) {
            var possibleSizes = ProductUtil.computeFrameAvailableSizes(imgWidth, imgHeight);
            setFieldValue("productSizeMetaData", possibleSizes);
        }
    }, [imgWidth, imgHeight]);

    useEffect(() => {
        if(isCustomSizeChecked && customWidth) {
            const customH = (customWidth * aspectRatio);
            const dpi = imgWidth/customWidth;

            if(dpi < 100) {
                setCustomSizeError('Size too big. Can yield poor print quality.');
                setFieldValue('customHeight', customH.toFixed(2));
                setFieldValue('productSize', '');
            } else {
                sizeData['NA'] = ProductUtil.createFrameSizeObject(customWidth, customH, dpi.toFixed(2));
                setFieldValue('customHeight', customH.toFixed(2));
                setFieldValue("productSizeMetaData", sizeData);
                setFieldValue('productSize', 'NA');
                setCustomSizeError(null);
            }
            
            
        } else if (isCustomSizeChecked && !customWidth) {
            setFieldValue('customHeight', '');
            setFieldValue('productSize', '');
        }
            
    }, [customWidth, isCustomSizeChecked]);

    const sizeBoxes = sizeKeys.filter(k => k !== 'NA').map(k => {
        var isSelected = selectedSize && selectedSize === k;
        return <div key={"customSize_"+k}  className={(isSelected?"selectedFrameSize": "")+" eachFrameSize"} 
                    onClick={() => {
                        setFieldValue('isCustomSize', '');
                        setFieldValue('productSize', k);
                    }}>
                    {sizeData[k].label}
                </div>
    });

    return <div id="frameSizeOptions">
        <h3 style={{margin: '5px 0'}}>Photo Size {selectedSizeData? <span className="dpiInfo">- {selectedSizeData.dpi} DPI</span>: null}</h3>
        {sizeBoxes.length === 0 &&
            <div className="flexColumn">
                <div className={"eachFrameSize"} style={{maxWidth: '90px', textAlign: 'center', color: "gray"}}>NA</div>
                {
                   imageUploaded &&
                   <span style={{color: "red"}}><i className="fa fa-exclamation" aria-hidden="true"></i> Photo is too small. No printing size available.</span>
                }

                {
                   !imageUploaded &&
                   <span style={{color: "gray"}}><i className="fa fa-exclamation-circle" aria-hidden="true"></i> Upload a photo to view it's available printable sizes.</span>
                }
            </div>
                
        }
        
        {sizeBoxes.length > 0 && 
            <div className="flexColumn">
                <div className="flexRow">
                    {sizeBoxes}
                </div>

                <div style={{fontSize: "120%", color: 'gray', margin: '10px 0'}} >
                    <Checkbox name="isCustomSize" label="Enter a Custom Size" onChange={(event) => {
                        setFieldValue('productSize', '');
                    }}/>
                </div>
                

                {
                    isCustomSizeChecked &&

                    <div className="flexColumn">
                        
                        <div className="flexRow" id="customSizeInput">
                            <Input label="Enter Width in (Inches)" name="customWidth" type="number" placeholder="E.g: 8.27"/>
                            <Input label="Height (Inches)" disabled={true} name="customHeight" placeholder="E.g: 11.7"/>
                        </div>

                        {customSizError && 
                            <span style={{fontSize: '12px', color: 'red'}}>
                                {customSizError}
                            </span>
                        }
                        
                    </div>
                    
                }
            </div>
            
        
        }

    </div>
};

export default PhotoFrameSizeInput;




// WEBPACK FOOTER //
// ./src/views/order/input/PhotoFrameSizeInput.js